import { useState } from 'react';

export default function useMergeState<Payload extends object>(
  initialState: Payload,
): [state: Payload, setMergedState: (newState: Partial<Payload> | Payload, isReset?: boolean) => void] {
  const [state, setState] = useState<Payload>(initialState);

  const setMergedState = (newState: Partial<Payload> | Payload, isReset = false) =>
    setState((prevState) => (isReset ? (newState as Payload) : { ...prevState, ...newState }));

  return [state, setMergedState];
}
